// Etiquetas de fecha en español neutro para fichas del panel analista: frescura
// relativa ("hoy 17:34", "ayer 09:10", "hace 3 días") con la fecha completa
// como respaldo ("15 sep 2026, 17:34"). Puro: recibe `now` para testear.
import moment from "moment";

const MONTHS_SHORT = [
	"ene", "feb", "mar", "abr", "may", "jun",
	"jul", "ago", "sep", "oct", "nov", "dic",
];

export function formatDateTimeEs(value) {
	if (!value) return "";
	const m = moment(value);
	if (!m.isValid()) return "";
	return `${m.date()} ${MONTHS_SHORT[m.month()]} ${m.year()}, ${m.format("HH:mm")}`;
}

export function relativeDayLabel(value, now = new Date()) {
	if (!value) return "";
	const m = moment(value);
	if (!m.isValid()) return "";
	const days = moment(now).startOf("day").diff(m.clone().startOf("day"), "days");
	if (days <= 0) return `hoy ${m.format("HH:mm")}`;
	if (days === 1) return `ayer ${m.format("HH:mm")}`;
	if (days < 7) return `hace ${days} días`;
	if (days < 30) {
		const weeks = Math.floor(days / 7);
		return weeks === 1 ? "hace 1 semana" : `hace ${weeks} semanas`;
	}
	if (days < 365) {
		const months = Math.floor(days / 30);
		return months <= 1 ? "hace 1 mes" : `hace ${months} meses`;
	}
	const years = Math.floor(days / 365);
	return years === 1 ? "hace 1 año" : `hace ${years} años`;
}

// "2025-03" → "mar 2025". Lo que no calce con YYYY-MM vuelve tal cual.
export function formatMonthLabel(yearMonth) {
	const [year, month] = String(yearMonth || "").split("-");
	const label = MONTHS_SHORT[Number(month) - 1];
	return label && year ? `${label} ${year}` : String(yearMonth || "");
}
